export default __webpack_public_path__ + "static/A03-f315a8ad3f8894a67e97534dcabecfa2.jpg";